<ng-container *ngIf="useServiceDetailWrapper; else noWrapper">
	<app-service-detail #serviceDetailRef [context]="context" [location]="pageLocation">
		<ng-container *ngTemplateOutlet="content"></ng-container>
	</app-service-detail>
</ng-container>
<ng-template #noWrapper>
	<ng-container *ngTemplateOutlet="content"></ng-container>
</ng-template>

<ng-template #content>
	<div class="row w-100 m-0 position-relative">
		<app-list-grid class="col p-0 print-documents-search-add {{showPrintDocumentAdd ? 'high-index': ''}}" *ngIf="!hideList"
			[items]="printDocuments"
			[determinantMapById]="determinantMapById"
			[baseUrl]="baseUrl"
			[expanded]=true
			[sortable]=true
			[showHeader]=false
			[statusIcons]=true
			[listToggle]=true
			showOperational="true"
			headingText="{{'Print documents available in the service' | translate}}"
			(deleteFunction)="deleteDocument($event)"
			(sortFunction)="sortDocuments($event)"
			(filterBy)="updateSearch($event)"
			(toggleOperationalFunction)="toggleOperational($event)"
			createNewText1Part="Select an existing document or click on"
			createNewText2Part="to create a new document"
			[hasTutorial]=false
			[headingTextSize]="'NONE'"
			[context]="context"
			[contextProperty]="'service'"
			[tutorialProperty]="'serviceCertificates'"
			(saveTutorial)="onServiceTutorialSaved()">
			<a (click)="showPrintDocumentAdd = true"
				class="btn list-search-add btn-dark" [ngClass]="{ 'show-list' : showTemplatesList }">{{'Add' | translate}}</a>
			<span class="search-add-btn-arrow" [ngClass]="{ 'show-list' : showTemplatesList }" (click)="showTemplatesList = !showTemplatesList">
				<i class="fas {{ showTemplatesList ? 'fa-caret-up' : 'fa-caret-down' }}"></i>
			</span>
			<div *ngIf="!showPrintDocumentAdd" class="template-list-container" [ngClass]="{ 'show-list' : showTemplatesList }">
				<span>{{ 'Start from template' | translate }}</span>
				<ul>
					<li *ngFor="let template of printTemplateList"><a (click)="selectedTemplate(template.id); showPrintDocumentAdd = true">{{ template.name }}</a></li>
				</ul>
			</div>
		</app-list-grid>
		<new-print-documents
							*ngIf="showPrintDocumentAdd"
							[templateId]="templateId"
							(modalClosedEvent)="closeLayer()"
							(modalAddedEvent)="addedCertificate()"
							[searchedName]="searchValue">
		</new-print-documents>
		<div class="shadow"></div>
	</div>
	<tab-menu class="container-fluid px-md-5 mb-3" *ngIf="hideList" [items]="printDocuments" [baseUrl]="baseUrl" [backToList]="true"></tab-menu>
	<ng-content></ng-content>
</ng-template>
